import { creditsEmptyInfo } from "../../components/credits-empty-info/credits-empty-info.strings.ts";

export const credit = {
  page_title: "Repair credits",
  balance_label: "Balance",
  view_print_statement: "View / print statement",
  activity_heading: "Activity",
  activity_empty: "No credit activity yet.",
  ...creditsEmptyInfo,
  sale_of_part: "Sale of {part_type}",
  part_id_line: "Part ID: {part_number}",
  kind_withdrawal: "Withdrawal",
  kind_repair_spend: "Repair",
  kind_platform_cut: "Platform cut",
  kind_part_sale: "Part sale",
} as const;
